/**
 * Fabricates a well-formed (but unsigned/unverified) JWT for demo-mode auth.
 *
 * Nothing on the client verifies the signature — OrganizationService.decodeClaims()
 * and core/utils/jwt.util.ts only base64url-decode the payload — so the "signature"
 * segment is a fixed placeholder. Claim names below match exactly what those two
 * decoders read: sub, customerProfileId, userType, authorities.
 */

/** Must match the id used across the org/customer-profile demo fixtures. */
export const DEMO_CUSTOMER_PROFILE_ID = 9001;

const DEMO_SUB = 'demo-admin@app-doctor.io';
const DEMO_USER_TYPE = 'CUSTOMER_ADMIN';
const DEMO_AUTHORITIES = ['ROLE_CUSTOMER_ADMIN'];

function base64UrlEncode(value: string): string {
  return btoa(value).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function buildToken(expiresInSeconds: number): string {
  const now = Math.floor(Date.now() / 1000);
  const header = { alg: 'HS256', typ: 'JWT' };
  const payload = {
    sub: DEMO_SUB,
    customerProfileId: DEMO_CUSTOMER_PROFILE_ID,
    userType: DEMO_USER_TYPE,
    authorities: DEMO_AUTHORITIES,
    iat: now,
    exp: now + expiresInSeconds
  };

  const encodedHeader = base64UrlEncode(JSON.stringify(header));
  const encodedPayload = base64UrlEncode(JSON.stringify(payload));
  return `${encodedHeader}.${encodedPayload}.demo-signature`;
}

const THIRTY_DAYS_SECONDS = 30 * 24 * 60 * 60;

export function buildDemoAccessToken(): string {
  return buildToken(THIRTY_DAYS_SECONDS);
}

export function buildDemoRefreshToken(): string {
  return buildToken(THIRTY_DAYS_SECONDS);
}
